/**
 * PROPS
 *
 * handleClaim => button claim click event | required | function
 * marginTop => margin top compoenent | default 0px | string
 * marginBottom => margin bottom compoenent | default 0px | string
 */

import React from "react";
import PropTypes from "prop-types";

const ClaimTicket = (props) => {

	const {
		handleClaim,
		marginTop,
		marginBottom,
	} = props;

	return (
		<>
			<div className="claim-container">
				<div className="claim-box">
					<p className="claim-box__text">Sudah Punya Tiket ? Segera claim tiket kamu sekarang</p>
					<button className="claim-box__button" type="button" onClick={() => handleClaim()}>
						Claim Ticket
					</button>
				</div>
			</div>
			<style jsx>{`
        .claim-container {
          position: relative;
          width: 100%;
          height: auto;
          margin: ${marginTop} 0 ${marginBottom} 0;
          box-sizing: border-box;
        }
        .claim-box {
          padding: 16px;
          border-radius: 8px;
          background: #DB284E;
        }
        .claim-box__text {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          color: #FFFFFF;
          margin: 0;
        }
        .claim-box__button {
          width: 121px;
          height: 34px;
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          text-transform: capitalize;
          border: none;
          color: #DB284E;
          background: #FFFFFF;
          border-radius: 8px;
          margin-top: 16px;
        }
    `}
			</style>
		</>
	);

};

ClaimTicket.propTypes = {
	handleClaim: PropTypes.func.isRequired,
	marginTop: PropTypes.string,
	marginBottom: PropTypes.string,
};

ClaimTicket.defaultProps = {
	marginTop: "0px",
	marginBottom: "0px",
};

export default ClaimTicket;
